module.exports = __webpack_public_path__ + "static/img/trainingCol.7170ab4c.svg";